// MASCARAS DE FORMATAÇÃO CPF / CNPJ
export const formatarCPFouCNPJ = (value: string) => {
  const digits = value.replace(/\D/g, "");
  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
  if (digits.length === 14) {
    return digits.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5",
    );
  }
  return value;
};
// ===================================================================================================

// MÁSCARA PARA CPF
export const formatarCPF = (value: string) => {
  const digits = value.replace(/\D/g, "");
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};
// ===================================================================================================

// MÁSCARA PARA CNPJ
export const formatarCNPJ = (value: string) => {
  const digits = value.replace(/\D/g, "");
  return digits.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    "$1.$2.$3/$4-$5",
  );
};
// ===================================================================================================

// MÁSCARA PARA CEP
export const formatarCEP = (value: string) => {
  const digits = value.replace(/\D/g, "");
  return digits.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
};
// ===================================================================================================

// MÁSCARA PARA TELEFONE (00) 00000-0000
export const formatarTelefone = (value: string) => {
  const digits = value.replace(/\D/g, "");
  return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
};
// ===================================================================================================

export const formatarData = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{4})\d+?$/, "$1");
};
// ===================================================================================================

// FUNÇÃO PARA VALIDAR E-MAIL
export function validarEmail(email: string): {
  valido: boolean;
  mensagem: string;
} {
  // Remove espaços
  const emailTrimado = email.trim();

  if (!emailTrimado) {
    return { valido: false, mensagem: "E-mail não pode ser vazio." };
  }

  // Verifica se tem exatamente um @
  const partes = emailTrimado.split("@");
  if (partes.length !== 2) {
    return { valido: false, mensagem: "E-mail deve conter um '@'." };
  }

  const [provedor, dominio] = partes;

  // Verifica se o provedor (parte antes do @) está preenchido
  if (!provedor || provedor.length === 0) {
    return { valido: false, mensagem: "Informe o provedor antes do '@'." };
  }

  // Verifica se o domínio (parte depois do @) está preenchido
  if (!dominio || dominio.length === 0) {
    return { valido: false, mensagem: "Informe o domínio após o '@'." };
  }

  // Verifica se o domínio contém pelo menos um ponto
  if (!dominio.includes(".")) {
    return {
      valido: false,
      mensagem: "O domínio deve conter um '.' (ex: gmail.com).",
    };
  }

  // Verifica se não começa ou termina com ponto
  if (dominio.startsWith(".") || dominio.endsWith(".")) {
    return {
      valido: false,
      mensagem: "O domínio não pode começar ou terminar com '.'.",
    };
  }

  // Verifica a extensão (.com, .br, .net, etc.) — mínimo 2 caracteres
  const partesdominio = dominio.split(".");
  const extensao = partesdominio[partesdominio.length - 1];
  if (extensao.length < 2) {
    return {
      valido: false,
      mensagem: "Extensão do e-mail inválida (ex: .com, .br).",
    };
  }

  // Regex completa para validação geral
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(emailTrimado)) {
    return { valido: false, mensagem: "Formato de e-mail inválido." };
  }

  return { valido: true, mensagem: "E-mail válido." };
}
// ===================================================================================================

// FUNÇÃO PARA CAPITALIZAR TEXTO (Primeira letra maiúscula, exceto palavras comuns)
export function capitalizarPrimeiraLetraMaiusculaDeCadaPalavra(texto: string): string {
  const excecoes = [
    "da",
    "de",
    "di",
    "do",
    "du",
    "das",
    "des",
    "dis",
    "dos",
    "dus",
  ];

  return texto
    .toLowerCase()
    .split(" ")
    .map((palavra, index) => {
      if (index !== 0 && excecoes.includes(palavra)) return palavra;
      return palavra.charAt(0).toUpperCase() + palavra.slice(1);
    })
    .join(" ");
}
// ===================================================================================================


export function capitalizarPrimeiraLetra(texto: string): string {
  if (!texto) return texto;
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
}